import { API_URLS, } from "@constants";
import { dehydrate, hydrate, } from "@hydra";
import type { IBracketStore, } from "@store";
import { awaitTruthy, loadAtTimeout, } from "@store/helpers";
import { fetchApiResponseHandler } from "@utils";
import { produce, } from 'immer';
import type { StateCreator, } from "zustand";
import type { ILeaderboardSlice, LeaderboardGetResult, } from "./types";

export const createLeaderBoardSlice: StateCreator<IBracketStore, [], [], ILeaderboardSlice> = ( set, get ) => {


	const fetch = async ( force = false, ) => {

		const { ready, fetching, } = get().bars.leaderboard;
		if(!force && (ready || fetching)) {
			return;
		}

		set(produce(state => {
			state.bars.leaderboard.ready = false;
			state.bars.leaderboard.fetching = true;
			state.bars.leaderboard.isLoading = true;
			state.bars.leaderboard.isError = false;
			state.bars.leaderboard.error = null;
		}));

		try {

			const { useStore, } = await import("@store/useStore");
			await awaitTruthy(useStore, state => state.wallet.ready);

			const { fetched, props, } = await hydrate("leaderboard");

			if(fetched) {
				set(produce(state => {
					Object.entries(props).forEach(([key, value]) => {
						// @ts-ignore -- fix later
						if(typeof key === "string" && key in state.bars.walletPoints) {
							state.bars.walletPoints[key] = value;
							state.bars.walletPoints.isLoading = false;
						}
					});
				}));
			}

			const data = await fetchApiResponseHandler<LeaderboardGetResult>({
				url: `${API_URLS.BARS}/leaderboard`,
				signal: new AbortController().signal,
				options: {
					method: "GET",
					headers: {
						wallet: get().wallet.address as string,
					},
				},
				onAbort: () => console.log("leaderboard request aborted"),
			});

			set(produce(state => {
				state.bars.leaderboard.data = data;
				state.bars.leaderboard.isLoading = false;
				state.bars.leaderboard.ready = true;
				state.bars.leaderboard.fetching = false;
			}));

			dehydrate("leaderboard", { data, });


		}
		catch (error) {
			set(produce(state => {
				state.bars.leaderboard.ready = true;
				state.bars.leaderboard.fetching = false;
				state.bars.leaderboard.isLoading = false;
				state.bars.leaderboard.isError = true;
				state.bars.leaderboard.error =
					error instanceof Error
						? error
						: new Error("An unknown error occurred");
			}));
		}

	};


	const update = (updater: (oldData: LeaderboardGetResult | null) => LeaderboardGetResult) => {
		set(produce(state => {
			state.bars.leaderboard.data = updater(state.bars.leaderboard.data);
		}));
	};


	const setData = (data: LeaderboardGetResult) => {
		set(produce(state => {
			state.bars.leaderboard.data = data;
		}));
	};


	const setError = (error: Error) => {
		set(produce(state => {
			state.bars.leaderboard.isError = true;
			state.bars.leaderboard.error = error;
		}));
	};


	const reset = () => {
		console.warn("createLeaderBoardSlice::reset not implemented");
	};


	const resetAsync = async () => {
		console.warn("createLeaderBoardSlice::resetAsync not implemented");
	};

	loadAtTimeout("bars.leaderboard", 2000);

	return {
		ready: false,
		fetching: false,
		data: null,
		isLoading: false,
		isError: false,
		error: null,
		fetch,
		reset,
		resetAsync,
		update,
		setData,
		setError,
	};

};
